











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class CampaignView extends Vue {
  public items: Common.Campaign[] = new Array(0);
  public params: Common.CampaignQuery = new Common.CampaignQuery();
  public exportQuery = new Common.ExportQuery('キャンペーン登録', this.params);  
  public sortOptions: any =   [{ value: 'id', text: 'ID' }];
  @Prop() public id:number;

  public created(){
    if (this.id){
      this.params.id = this.id;
      this.params.state = Common.CampaignStatus.all;
    } 
  }
  public async onCreate(obj: Common.Campaign) {
    const workflows = this.$api.formatter.getOptions('workflow_campaign');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj); 
  }
  
  public showCampaignEntry(campaignId:string){
      this.$router.push(String.format('/operation/campaignEntry?campaignId={0}',campaignId));
  }  
}
